import {
  type ContractDto,
  ContractDtoBidBasisEnum,
} from '@b-stock/contract-api-client'
import { useIsTranslationDefined } from '@b-stock/fe-core/bstock-next/hooks'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { CommonStrings } from '@b-stock/fe-core/locale'

export const ContractBidFulfillmentUnit = ({
  contract,
}: {
  contract: ContractDto
}) => {
  const bidFulfillmentUnit =
    (contract.bidBasis === ContractDtoBidBasisEnum.Absolute
      ? contract.bidUnit
      : contract.fulfillmentQuantityUnits) ?? 'ITEMS'

  const translationId = useIsTranslationDefined(
    `Contract.bidUnitsShort.${bidFulfillmentUnit}`
  )

  return translationId ? (
    <FormattedMessage id={translationId} />
  ) : (
    <CommonStrings.NotAvailableAbbr.Component />
  )
}
